<template>
  <div class="alxq2">
    <div v-wechat-title="$route.meta.title"></div>

    <div class="dhtBox">
      <div class="cdBox">
      <div class="logo"></div>

        <div @click="shouye" class="cd">首页</div>
        <div @click="fuwu" class="cd">产品服务</div>
        <div @click="sxy" class="cd">商学院</div>
        <div @click="cpgyl" class="cd">产品供应链</div>
        <div @click="hzal" class="cd bxz">合作案例</div>
        <div @click="ydd( hsk )" class="cd yddapp">
          移动端
          <div class="yddxiazai" v-if="hsk == 2">
            <div class="hezi">
              <!-- <div class="img img1"></div> -->
              <!-- <div class="text">米商云</div> -->
            </div>
            <div class="hezi">
              <div class="img img2">
                <img src="../../assets/images/9774f492e19d7134dca0552612911f5.jpg" alt="">
              </div>
              <div class="text">米小礼</div>
            </div>
            <div class="hezi">
              <!-- <div class="img img3"></div> -->
              <!-- <div class="text">商e通</div> -->
            </div>
          </div>
        </div>
        <!-- <div @click="mk" class="cd">米珈</div> -->
        <div @click="gywm" class="cd">关于我们</div>
      </div>
    </div>
    <div class="lbBox"></div>
    <div class="alxqboxbox">
      <div class="alxqbox">
        <div class="text text1">2021 - 6 - 16</div>
        <div class="text text2">餐饮专属|爆品营销策略助力生意火爆</div>
        <div class="text text3">
          夏季来临，尤其是炎热的北方，高温多雨的天气会让很多餐饮店铺受影响，尤其是串串、火锅等有明显季节性淡季的品类。
          <br />

        在这样的情况下，如果想在炎炎夏日让生意像温度一样“火爆”，可以考虑以下几单品作为爆品营销的产品素材。
          <br />

         这几款产品均为 一折 上下即可采购的酒水，涵盖两大重要的品类：葡萄酒和白酒。同时，品牌和系列也均选择茅台集团、五粮液股份、白马歌德系列等有高影响力的产品，可以起到 快速吸引消费者眼球+参与活动 的效果。

         
        </div>
        <div style="width:100%;">
          <img src="http://www.micreat.com/static/img/cyzs1.f25db92.png" alt="">

          </div>
          <div style="width:100%;">
          <img src="http://www.micreat.com/static/img/cyzs2.e3e145e.png" alt="">

          </div>
          <div style="width:100%;">
          <img src="http://www.micreat.com/static/img/cyzs3.b770f6d.png" alt="">

          </div>
          <div style="width:100%;">
          <img src="http://www.micreat.com/static/img/cyzs4.f5ae4f9.png" alt="">

          </div>
          <div style="width:100%;">
          <img src="http://www.micreat.com/static/img/cyzs5.74cc978.png" alt="">

          </div>
          <div style="width:100%;">
          <img src="http://www.micreat.com/static/img/cyzs6.757395c.png" alt="">

          </div>
                  <div class="text text3">
          活动示例
          <br />

       活动主题： 夏日狂欢，储值即送酒水豪礼，可存可带走
          <br />

        活动内容： 夏日随饮，酒再好也莫贪杯呦
  <br />

        储值200送：京东在售 198元苏黛庄园经典干红葡萄酒一瓶储值500送： 京东在售 599元五粮液股份一尊天下豪华装一瓶储值1000送： 京东在售1399元贵州茅台镇壮丽河山酒一箱4瓶储值4000送： 京东在售 5394元贵州茅台集团茅乡玉液A50尊品6瓶

        </div>
        
        <div class="gjcanwxwbqqbox">
          <div class="gjcanwxwbqqleft"></div>
          <div class="gjcanwxwbqqright">
            <div @click="shareToQQ()" class="gjcanwxwbqqrightimg gjcanwxwbqqrightimg1"></div>
            <div @click="WeixinJSBridge()" class="gjcanwxwbqqrightimg gjcanwxwbqqrightimg2"></div>
            <div  @click="shareToMicroblog()" class="gjcanwxwbqqrightimg gjcanwxwbqqrightimg3"></div>
          </div>
        </div>
        <div class="hengxian"></div>
        <div class="xgaltext">相关案例</div>
        <div class="xgalbox">
          <div @click="tiaozhuan(1)" class="xgalboxs xgalboxs1">
            <div class="xgalboxstext">饺子馆会员制简单有效促使精准回流</div>
          </div>
          <div @click="tiaozhuan(2)" class="xgalboxs xgalboxs2">
            <div class="xgalboxstext">健身俱乐部引流锁客经典案</div>
          </div>
          <div @click="tiaozhuan(3)" class="xgalboxs xgalboxs3">
            <div class="xgalboxstext">用2个步骤，一周新增628客户，营收91万！</div>
          </div>
        </div>
      </div>
    </div>
    
  </div>
</template>

<script>
import API from "@/service/common.service.js";

export default {
  data() {
    //

    return {
      active: 0,
      hsk:1,

    };
  },
  mounted() {},
  methods: {
    //分享到QQ好友(PC端可用)
    shareToQQ() {
      //此处分享链接内无法携带图片
      const share = {
        title: "米创集团",
        desc: "",
        // share_url: "http://www.micreat.com/#/"
        share_url: "http://www.micreat.com?projectId=1"

      };
      // var qqqq = "https://connect.qq.com/widget/shareqq/index.html?url=" +
      var qqqq = "https://api.pwmqr.com/qrcode/create/?url=" +

          encodeURIComponent(share.share_url) +
          "&title=" +
          share.title +
          "&desc=" +
          share.desc

        window.open(qqqq, 'newwindow', 'height=400,width=400,top=200,left=600');

    },
    //分享到QQ空间(可用)
    WeixinJSBridge() {
      //此处分享链接内无法携带图片
      const share = {
        title: "米创集团",
        desc: "",
        share_url: "http://www.micreat.com?projectId=1"
      };
      var wwww = "https://api.pwmqr.com/qrcode/create/?url=" +
          encodeURIComponent(share.share_url) +
          "&title=" +
          share.title +
          "&desc=" +
          share.desc

        window.open(wwww, 'newwindow', 'height=400,width=400,top=200,left=600');
    },
    //分享到微博(可用)
    shareToMicroblog() {
      //自定义内容
      const share = {
        title: "米创集团",
        image_url: ["https://api.mxl.mclandian.com/images/favicon.ico"],
        share_url: "http://www.micreat.com/#/"
      };
      //跳转地址
      var bbbb =  "https://service.weibo.com/share/share.php?url=" +
          encodeURIComponent(share.share_url) +
          "&title=" +
          share.title +
          "&pic=" +
          share.image_url +
          "&searchPic=true"

        window.open(bbbb, 'newwindow', 'height=1000,width=1000,top=200,left=100');
    },
     tiaozhuan(e){
      if( e == 3){
        this.$router.push({
        path: "/alxq5",
      });
      }else if( e == 2){
      this.$router.push({
        path: "/alxq4",
      });
      }else if( e == 1){
        this.$router.push({
        path: "/alxq2",
      });
      }
    },
    ydd(e){
       if(e == 1){
        this.hsk = 2
      }else{
        this.hsk = 1

      }
      console.log(this.hsk)
      
    },
    shouye() {
      this.$router.push({
        path: "/",
      });
    },
    fuwu() {
      this.$router.push({
        path: "/cpfu",
      });
    },
    sxy() {
      this.$router.push({
        path: "/sxy",
      });
    },
    cpgyl() {
      this.$router.push({
        path: "/cpgyl",
      });
    },
    hzal() {
      this.$router.push({
        path: "/hzal",
      });
    },
    mk() {
      this.$router.push({
        path: "/mk",
      });
    },
    gywm() {
      this.$router.push({
        path: "/gywm",
      });
    },
  },
};
</script>
<style lang="scss">
.alxq2 {
  font-size: 0.16rem;
  background: #fff;
  .dhtBox {
    .bxz {
      border-bottom: 2px solid #fff;
    }
  }
  .lbBox {
    width: 100%;
    height: 5.17rem;
    background: url("../../../src/assets/images/1501.png");
    background-size: 100% 100%;
    // position: absolute;
    // top: 0;
    z-index: -1;
    margin-top: -0.98rem;
  }
  .alxqboxbox {
    width: 100%;
    background: #fff;
    padding-bottom: 0.8rem;
    .alxqbox {
      width: 1200px;
      margin: 0 auto;
      padding-top: 1.1rem;
      .imgbox {
        width: 10rem;
        height: 5rem;
        background: #0f0;
        margin: 0 auto;
        margin-bottom: 0.4rem;
        background: url('../../assets/images/1625137306(1).jpg') no-repeat center;
      }
      .text {
        display: flex;
        justify-content: left;
        align-items: center;
      }
      .text1 {
        font-size: 0.18rem;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #626262;
        margin-bottom: 0.2rem;
      }
      .text2 {
        font-size: 0.34rem;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #000000;
        margin-bottom: 0.9rem;
      }
      .text3 {
        font-size: 0.14rem;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #999999;
        line-height: 0.4rem;
        margin-bottom: 0.87rem;
      }
      .gjcanwxwbqqbox {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 0.4rem;
        .gjcanwxwbqqleft {
          font-size: 0.18rem;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #2d60fe;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .gjcanwxwbqqright {
          display: flex;
          justify-content: center;
          align-items: center;
          .gjcanwxwbqqrightimg {
            width: 0.3rem;
            height: 0.3rem;
            background-size: 100% 100%;
            margin-left: 0.5rem;
          }
          .gjcanwxwbqqrightimg1 {
            background: url("../../assets/images/qqt.png") no-repeat center;
          }
          .gjcanwxwbqqrightimg2 {
            background: url("../../assets/images/wxt.png") no-repeat center;
          }
          .gjcanwxwbqqrightimg3 {
            background: url("../../assets/images/wbt.png") no-repeat center;
          }
        }
      }
      .hengxian {
        width: 100%;
        height: 0.01rem;
        background: #efefef;
        margin-bottom: 0.8rem;
      }
      .xgaltext {
        display: flex;
        justify-content: left;
        align-items: center;
        font-size: 0.34rem;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #2a2e2e;
        margin-bottom: 0.5rem;
      }
      .xgalbox {
        display: flex;
        flex-wrap: wrap;
        .xgalboxs {
          width: 3.86rem;
          height: 2.89rem;
          background-size: 100% 100%;
          margin-right: 0.2rem;
          position: relative;
          .xgalboxstext {
            width: 387px;
            height: 52px;
            background: rgba($color: #010206, $alpha: 0.3);
            position: absolute;
            bottom: 0;
            display: flex;
            justify-content: left;
            align-items: center;
            padding-left: 0.15rem;
            box-sizing: border-box;
            font-size: 0.2rem;
            font-family: Source Han Sans CN;
            font-weight: 500;
            color: #ffffff;
          }
        }
        .xgalboxs1 {
          background: url("../../assets/images/a3.png") no-repeat center;
        }
        .xgalboxs2 {
          background: url("../../assets/images/a1.png") no-repeat center;
        }
        .xgalboxs3 {
          background: url("../../assets/images/a2.png") no-repeat center;
        }
        .xgalboxs:nth-child(3n) {
          margin-right: 0rem;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/alxq8/index.vue